import { subscribeToMedplumLogout } from '@eluve/medplum-client/logout-signal';

type MedplumCleanupModule = Pick<
  typeof import('@eluve/medplum-client'),
  'clearMedplumLoginsForTab'
>;

export const installMedplumLogoutListener = (
  baseUrl: string | undefined,
  loadMedplum: () => Promise<MedplumCleanupModule> = () =>
    import('@eluve/medplum-client'),
): (() => void) =>
  subscribeToMedplumLogout(async () => {
    const { clearMedplumLoginsForTab } = await loadMedplum();
    await clearMedplumLoginsForTab(baseUrl);
  });
